import { HTMLAttributes } from "react";
import ButtonFactory from "@components/Button/ButtonFactory";
import { ButtonType } from "@components/Button/utils/types";
import { HeaderCommonProps } from "@components/Header/types";
import IconFactory from "@components/Icon/IconFactory";
import { IconTypeEnum } from "@components/Icon/utils/types";
import { useHandleUserAction } from "@features/mySph/hooks/useHandleUserAction";
import { useWindowSize } from "@hooks/useWindowSize";
import { cn } from "@util/helpers";

export type LoginTriggerProps = Pick<
  HTMLAttributes<HTMLDivElement>,
  "className"
> &
  Pick<HeaderCommonProps, "textClassName">;

const MyAccountLoginTrigger = ({
  className = "lg:p-3",
  textClassName,
}: LoginTriggerProps): React.ReactElement => {
  const { isScreenLG } = useWindowSize();
  const { handleUserLogin } = useHandleUserAction();

  return (
    <ButtonFactory
      className={cn(
        "cursor-pointer font-poppins text-2xs font-semibold opacity-100",
        "border-0 lg:border",
        "flex items-center justify-center rounded-[25px] leading-none tracking-tightest focus-within:outline-0 focus:outline-0 lg:hover:bg-gray-175",
        className,
        textClassName
      )}
      testId="user-login-trigger"
      aria-label="login trigger"
      buttonType={ButtonType.Secondary}
      onClick={handleUserLogin}
      icon={
        !isScreenLG ? <IconFactory type={IconTypeEnum.profile} /> : undefined
      }
      text={isScreenLG ? "Sign in / Sign up for free" : undefined}
    />
  );
};

export default MyAccountLoginTrigger;
